var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeatSteak = function SvgMeatSteak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.114 4.737a8.264 8.264 0 0 0-8.876-.223 15.137 15.137 0 0 1-5.367 1.865l-.12.02a1.301 1.301 0 0 0-1.087 1.284v0c-.003.362.145.708.41.955a11.792 11.792 0 0 0 15.267.5 2.704 2.704 0 0 0 .997-2.117v0a2.762 2.762 0 0 0-1.224-2.284Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.004 6.58-1 2.502M9.67 6.58l-1 2.502M1.664 7.683v4.008a3.38 3.38 0 0 0 1.402 2.724 11.798 11.798 0 0 0 13.87 0 3.38 3.38 0 0 0 1.402-2.724V7.02",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMeatSteak;